module.exports = __webpack_public_path__ + "static/fonts/MyriadPro-BlackCond.6b7f583.ttf";